import { render, staticRenderFns } from "./vendDetail.vue?vue&type=template&id=2d1c0464&scoped=true&"
import script from "./vendDetail.vue?vue&type=script&lang=js&"
export * from "./vendDetail.vue?vue&type=script&lang=js&"
import style0 from "./vendDetail.vue?vue&type=style&index=0&id=2d1c0464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1c0464",
  null
  
)

export default component.exports